import React from 'react';

import { useNavigate } from 'react-router-dom';
import {Button} from '@mui/material';
import logo from '../images/thumbnail_logo512D.png';

export default function PageError() {
  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate('/'); // 홈 페이지로 이동
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', textAlign: 'center' }}>
      <div style={{marginBottom: '50px'}}>
        <img src={logo} alt="Logo" style={{ width: '150px', height: '150px' }} />
        <h2 style={{ fontSize: '48px' }}>You've found a page that doesn't exist</h2>
      </div>

      <Button onClick={handleGoHome} style={{ fontSize: '18px' }} variant="contained">Go Home</Button>
    </div>
  );
}
